import { render, staticRenderFns } from "./LiveIcon.vue?vue&type=template&id=113c48ec&scoped=true&"
import script from "./LiveIcon.vue?vue&type=script&lang=js&"
export * from "./LiveIcon.vue?vue&type=script&lang=js&"
import style0 from "./LiveIcon.vue?vue&type=style&index=0&id=113c48ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113c48ec",
  null
  
)

export default component.exports